import { escapeHtml } from "../utils/escapeHtml";

interface EmptyStateOptions {
  icon?: string;
  message: string;
  hint?: string;
}

export function renderEmptyState(container: HTMLElement, opts: EmptyStateOptions): void {
  container.innerHTML = `
    <div class="empty-state">
      ${opts.icon ? `<div class="empty-state-icon">${opts.icon}</div>` : ""}
      <p class="empty-state-message">${escapeHtml(opts.message)}</p>
      ${opts.hint ? `<p class="empty-state-hint">${escapeHtml(opts.hint)}</p>` : ""}
    </div>
  `;
}
